var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatBoldi = function SvgChatBoldi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12.3 16H9.415A.42.42 0 0 1 9 15.582V8.418A.42.42 0 0 1 9.415 8h2.357a1.974 1.974 0 0 1 1.457 3.284A2.454 2.454 0 0 1 12.3 16m-2.471-.836H12.3a1.612 1.612 0 0 0 0-3.224H9.829zm0-4.048h1.943a1.135 1.135 0 0 0 0-2.269H9.829z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatBoldi);
export default ForwardRef;